import React from "react";

interface InitialsCircleProps {
  name: string;
  initials?: string;
  gender?: "Male" | "Female" | "Other";
}

const InitialsCircle: React.FC<InitialsCircleProps> = ({
  initials,
  gender,
}) => {
  const getClassNames = () => {
    switch (gender) {
      case "Male":
        return "bg-blue-100 border-blue-200 text-blue-500";
      case "Female":
        return "bg-pink-100 border-pink-200 text-pink-500";
      default:
        return "bg-secondary border-secondary text-white";
    }
  };

  return (
    <div
      className={`w-16 h-16 flex items-center justify-center rounded-full text-xl font-bold ${getClassNames()} border-4`}
    >
      {initials}
    </div>
  );
};

export default InitialsCircle;
